// en, de, fr
export default {
	en: {
		Dashboard: 'Dashboard',
	},
	fr: {
		Dashboard: 'Tableau de bord',
	},
}
